import { render, staticRenderFns } from "./ModalAcceptTerms.vue?vue&type=template&id=2264aae9&scoped=true&"
import script from "./ModalAcceptTerms.vue?vue&type=script&setup=true&lang=ts&"
export * from "./ModalAcceptTerms.vue?vue&type=script&setup=true&lang=ts&"
import style0 from "./ModalAcceptTerms.vue?vue&type=style&index=0&id=2264aae9&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2264aae9",
  null
  
)

export default component.exports